import React, {useContext} from 'react'
import {useDependency, useResourceFromPath} from 'hooks'
import { Link } from 'react-router-dom'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import EditIcon from '@material-ui/icons/Edit'
import IconButton from '@material-ui/core/IconButton'
import { PageContainer } from 'components'
import { LogInstructionsContext } from 'contexts'

const Show = () => {
  const {id} = useResourceFromPath()
  const log_instructions = useContext(LogInstructionsContext.ReactContext)

  useDependency(() => (
    log_instructions.actions.show(id, {
      include: ''
    })
  ), [id])

  const instruction = log_instructions.selected

  return (
    <PageContainer>
      <Typography variant='h4'>Log Instruction - {instruction.name}</Typography>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell style={{width: 30}} variant='head'>Actions</TableCell>
            <TableCell>
              <Link to={`/log_instructions/${instruction.id}/edit`}>
                <IconButton>
                  <EditIcon/>
                </IconButton>
              </Link>
            </TableCell>
          </TableRow>
            <TableRow>
              <TableCell variant='head'>Name</TableCell>
              <TableCell>{String(instruction.name || '')}</TableCell>
            </TableRow>
        </TableBody>
      </Table>
      <br/>
    </PageContainer>
  )
}

export default (props) => (
  <LogInstructionsContext>
    <Show {...props} />
  </LogInstructionsContext>
)
